import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  variant?: 'default' | 'hover';
}
export function Card({
  children,
  className = '',
  variant = 'default',
  ...props
}: CardProps) {
  const baseStyles = 'bg-[#141B3A] border border-[#1E293B] rounded-xl overflow-hidden';
  const hoverStyles = variant === 'hover' ? 'transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#0A0E27]/50 hover:border-[#334155]' : '';
  return <div className={`${baseStyles} ${hoverStyles} ${className}`} {...props} data-id="element-297">
      {children}
    </div>;
}